(() => {
  const root = document.querySelector('[data-chikas-silhouettes]');
  if (!root) return;

  const track = root.querySelector('[data-chikas-silhouettes-grid]');
  const hint = root.querySelector('[data-silhouettes-hint]');
  const prev = root.querySelector('[data-silhouettes-prev]');
  const next = root.querySelector('[data-silhouettes-next]');
  if (!track || !hint || !prev || !next) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const step = () => {
    const card = track.querySelector('.silhouette');
    if (!card) return Math.max(180, track.clientWidth * 0.72);
    const gap = parseFloat(getComputedStyle(track).gap || '16') || 16;
    return card.getBoundingClientRect().width + gap;
  };

  const sync = () => {
    const max = track.scrollWidth - track.clientWidth - 2;
    const canScroll = max > 8;
    hint.hidden = !canScroll;
    hint.setAttribute('aria-hidden', canScroll ? 'false' : 'true');
    prev.classList.toggle('is-disabled', track.scrollLeft <= 4);
    next.classList.toggle('is-disabled', track.scrollLeft >= max);
  };

  const scrollByDir = (dir) => {
    track.scrollBy({
      left: dir * step(),
      behavior: reduce ? 'auto' : 'smooth',
    });
  };

  prev.addEventListener('click', () => scrollByDir(-1));
  next.addEventListener('click', () => scrollByDir(1));
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync, { passive: true });

  if ('ResizeObserver' in window) {
    new ResizeObserver(sync).observe(track);
  }

  sync();
})();
